import BaseApi from '~/api/base';
class DocumentComparisons extends BaseApi {
    constructor() {
        super('/document-comparisons');
    }
}
const DocumentComparisonsApi = new DocumentComparisons();
export default DocumentComparisonsApi;
